export const REPOPULATION_PENDING_STATUS = 'repopulating'
export const REPOPULATION_ERROR_STATUS = 'error'
export const REPOPULATION_IDLE_STATUS = 'idle'
export const DEFAULT_LIST_FOLDER_NAME = 'Default'
